var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00899 10.8451C2.03751 11.0612 2.13589 11.2621 2.28916 11.4172C2.44243 11.5723 2.64218 11.673 2.85799 11.7041L11.116 12.8841L12.296 21.1421C12.3269 21.3579 12.4276 21.5578 12.5827 21.7111C12.7378 21.8645 12.9388 21.9629 13.155 21.9915C13.3712 22.02 13.5908 21.9771 13.7804 21.8692C13.97 21.7614 14.1191 21.5945 14.205 21.3941L21.919 3.39405C21.9977 3.21036 22.0195 3.00731 21.9817 2.81108C21.9439 2.61485 21.8482 2.43444 21.7069 2.29314C21.5656 2.15183 21.3852 2.0561 21.189 2.0183C20.9927 1.9805 20.7897 2.00235 20.606 2.08105L2.60599 9.80005C2.40652 9.88581 2.24039 10.0342 2.13268 10.2227C2.02498 10.4112 1.98156 10.6297 2.00899 10.8451ZM13.771 17.3281L13.06 12.3541L18.036 7.37805L13.771 17.3281ZM16.621 5.96505L11.647 10.9391L6.67099 10.2291L16.621 5.96505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat);
export default __webpack_public_path__ + "static/media/send-chat.303c816c74e1b98de999f323fb44576b.svg";
export { ForwardRef as ReactComponent };